import React from 'react';
import { RiLockFill, RiExternalLinkFill } from 'react-icons/ri';
import { useTranslate } from '../../hooks/useTranslate';

interface TableAccessRequestButtonProps {
    catalog?: string;
    schema?: string;
    tableName?: string;
    fullTableName?: string;
    className?: string;
    onRequestSubmitted?: (success: boolean, message?: string) => void;
}

const TableAccessRequestButton: React.FC<TableAccessRequestButtonProps> = ({
    catalog = '',
    schema = '',
    tableName = '',
    fullTableName = '',
    className = '',
    onRequestSubmitted
}) => {
    const { t } = useTranslate();
    const handleRequestAccess = () => {
        // Open Access Pilot app in new tab
        window.open('https://accesspilot.rich.com', '_blank', 'noopener,noreferrer');
        
        // Notify parent of successful request submission
        if (onRequestSubmitted) {
            onRequestSubmitted(true, 'Access request submitted successfully');
        }
    };

    return (
        <button
            onClick={handleRequestAccess}
            className={`inline-flex items-center gap-2 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors text-sm font-medium ${className}`}
        >
            <RiLockFill className="w-4 h-4 text-white" />
            {t('Request Access')}
            <RiExternalLinkFill className="w-3 h-3 text-white" />
        </button>
    );
};

export default TableAccessRequestButton;